export const bannerTypes = {
  FETCH_BANNER_MAIN_LOADING: "FETCH_BANNER_MAIN_LOADING",
  FETCH_BANNER_MAIN_SUCCESS: "FETCH_BANNER_MAIN_SUCCESS",
  FETCH_BANNER_MAIN_FAILURE: "FETCH_BANNER_MAIN_FAILURE",
};
